<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">CONTENTS</h1>
<div class="SOM_pre"><a href="#/pre2">Preface</a></div>
<div class="SOM_pre"><a href="#/pre3">Acknowledgments</a></div>
<div class="SOM_chap"><a href="#/p1chap1"><b>1</b> Terms of Justice</a></div>
<div class="SOM_part"><a href="#/p2">PART 1: APOCALYPTIC JUSTICE</a></div>
<div class="SOM_chap"><a href="#/p2chap1"><b>2</b> Apocalypse of Justice</a></div>
<div class="SOM_chap"><span href="#/p2chap2" title="Link target outside of Sample"><b>3</b> Justice Beyond Systems</span></div>
<div class="SOM_chap"><span href="#/p2chap3" title="Link target outside of Sample"><b>4</b> Being Just</span></div>
<div class="SOM_chap"><span href="#/p2chap4" title="Link target outside of Sample"><b>5</b> The Just One</span></div>
<div class="SOM_chap"><span href="#/p2chap5" title="Link target outside of Sample"><b>6</b> Becoming Just</span></div>
<div class="SOM_chap"><span href="#/p2chap6" title="Link target outside of Sample"><b>7</b> Justice and Law</span></div>
<div class="SOM_chap"><span href="#/p2chap7" title="Link target outside of Sample"><b>8</b> The Spirit of Justice</span></div>
<div class="SOM_chap"><span href="#/p2chap8" title="Link target outside of Sample"><b>9</b> Justice Among the Nations: Israel</span></div>
<div class="SOM_part"><span href="#/p3" title="Link target outside of Sample">PART 2: MESSIANIC LIFE</span></div>
<div class="SOM_chap"><span href="#/p3chap1" title="Link target outside of Sample"><b>10</b> Messianic Public Service</span></div>
<div class="SOM_chap"><span href="#/p3chap2" title="Link target outside of Sample"><b>11</b> Messianic Freedom</span></div>
<div class="SOM_chap"><span href="#/p3chap3" title="Link target outside of Sample"><b>12</b> Messianic Solidarity</span></div>
<div class="SOM_chap"><span href="#/p3chap4" title="Link target outside of Sample"><b>13</b> Messianic Spreading</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Suggestions for Further Reading</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Glossary and Translations</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Praise for <i>Resurrecting Justice</i></span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?5151c047